import { reducer } from './modules';

export { default as districtActions } from './modules';
export { default as districtSaga } from './sagas';
export { default as districtSelectors } from './selectors';
export { default as districtOperations } from './operations';

export default reducer;
